module.exports = __webpack_public_path__ + "img/cross-e-commerce.ba9ec85.webp";